<article
  class="information-card bg-white d-flex flex-column w-100 h-100 overflow-hidden"
>
  @if (showImage() && image(); as cardImage) {
    <figure class="information-card__image-container w-100 overflow-hidden m-0">
      <picture>
        <img *scImage="cardImage" class="w-100 h-100 object-fit-cover" />
      </picture>
    </figure>
  }

  <div
    class="information-card__content d-flex flex-column flex-grow-1 text-break"
  >
    <h3 *scText="title()" class="mt-3"></h3>
    <div *wlGenericRichText="content()" class="flex-grow-1 mb-3"></div>

    <crnt-button-alt variant="secondary" [fullWidth]="true">
      <a *wlGenericLink="button()"></a>
    </crnt-button-alt>
  </div>
</article>
